import { render, staticRenderFns } from "./lkuCustomer.vue?vue&type=template&id=11aeff7c&"
import script from "./lkuCustomer.vue?vue&type=script&lang=js&"
export * from "./lkuCustomer.vue?vue&type=script&lang=js&"
import style0 from "./lkuCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports